var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersons = function SvgPersons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15,
    fill: "currentColor",
    viewBox: "0 0 10 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.626 6.25a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25m.034 1a4.595 4.595 0 0 1 4.593 4.592v2.466c0 .319-.26.578-.578.578H.578a.58.58 0 0 1-.578-.58v-2.395A4.664 4.664 0 0 1 4.66 7.25"
  })));
};
export default SvgPersons;